import axios from "axios";
import { API_URL } from "../config/api";

const defaultHeaders = {
  "Content-Type": "application/json",
};

export const apiRequest = async (
  endpoint,
  method = "GET",
  data = {},
  params = {},
) => {
  const url = `${API_URL}/${endpoint}`;

  const requestConfig = {
    method,
    url,
    withCredentials: true,
    headers: defaultHeaders,
    params: method === "GET" ? { ...params } : {},
    data: method !== "GET" ? { ...data } : null,
  };

  try {
    const response = await axios(requestConfig);

    if (response.data[0]?.error_msg) {
      throw new Error(response.data[0].error_msg);
    }

    return response.data;
  } catch (error) {
    console.error(`Błąd API: ${error.message}`);
    return null;
  }
};
